import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import AprilAtonementBanner from '~/main/components/AprilAtonementBanner';
import { fetchNodeIfNeeded } from '~/nodes/actions';
import Prizes from '~/main/components/Prizes';

const MonthlySubscriberPrizeDraw = (props) => {
	const { dispatch, nodes } = props;
	useEffect( () => {
		dispatch(fetchNodeIfNeeded('monthly-subscriber-prize-draw'))
	}, [])
	return (
    <div id="monthly-prize">
      <div className="monthly-subscriber-prize-draw">
        { nodes['monthly-subscriber-prize-draw'] && nodes['monthly-subscriber-prize-draw'].body && 
          <div className="margin">
            <h1>{nodes['monthly-subscriber-prize-draw'].title[0].value}</h1>
            <div className="introduction" dangerouslySetInnerHTML={{ __html: nodes['monthly-subscriber-prize-draw'].body[0].value}}></div>
          </div>
        }
        <Prizes category="monthly" variant="monthly" />
      </div>
    </div>
	)
}

MonthlySubscriberPrizeDraw.fetchData = (store, route, match) => {
	return store.dispatch(fetchNodeIfNeeded('monthly-subscriber-prize-draw'))
}

export default connect( state => ( { nodes: state.nodes } )) (MonthlySubscriberPrizeDraw)